import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import TimerIcon from "@mui/icons-material/Timer";
import { useEffect, useState } from "react";
import { Box, IconButton, Typography } from "@mui/material";

function Countdown({ onClick = () => {} }) {
  const [time, setTime] = useState(75 * 60);
  const [start, setStart] = useState(false);

  useEffect(() => {
    let timerId;
    if (start && time > 0) {
      timerId = setTimeout(() => {
        setTime((prev) => prev - 1);
      }, 1000);
    } else if (time === 0 && start) {
      onClick();
      setStart(false);
    }
    return () => {
      clearTimeout(timerId);
    };
  }, [start, time, onClick]);

  const handleToggleStart = () => {
    setStart(!start);
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 1,
        py: 0.75,
        borderRadius: 2,
        bgcolor: start ? "#e8f9ed" : "#edf7ff",
        border: "1px solid #e5edf5",
        color: start ? "#35c759" : "#2196f3",
      }}
    >
      <TimerIcon fontSize="small" />
      <Typography
        sx={{
          minWidth: 58,
          color: "#07111f",
          fontWeight: 700,
          fontVariantNumeric: "tabular-nums",
        }}
      >
        {formatTime(time)}
      </Typography>
      <IconButton
        size="small"
        onClick={handleToggleStart}
        sx={{
          width: 30,
          height: 30,
          bgcolor: "#ffffff",
          color: start ? "#35c759" : "#2196f3",
          "&:hover": { bgcolor: "#ffffff" },
        }}
      >
        {start ? <PauseIcon fontSize="small" /> : <PlayArrowIcon fontSize="small" />}
      </IconButton>
    </Box>
  );
}

export default Countdown;
